export const COLLECTABLE_MAIN_WIDGET_CARD_HEIGHT = {
  isMobile: 320,
  isDesktop: 450,
};
